import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=9bcbfb9e&scoped=true"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bcbfb9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9bcbfb9e')) {
      api.createRecord('9bcbfb9e', component.options)
    } else {
      api.reload('9bcbfb9e', component.options)
    }
    module.hot.accept("./Loading.vue?vue&type=template&id=9bcbfb9e&scoped=true", function () {
      api.rerender('9bcbfb9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UI/Loading.vue"
export default component.exports